/* istanbul ignore next */
import './wa-bonaeditor-raw-adapter';
/* istanbul ignore next */
export { WaBonaEditorAdapter as default } from './wa-bonaeditor-adapter';
